export const BIG_SCREEN = window.innerWidth >= 3000;
export const SMALL_SCREEN = window.innerWidth <= 1800;